// Estilos do seletor de cor de agrupamento exibido no menu de contexto do diagrama
const styles = (theme) => ({
  swatchRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.75,
    px: 2,
    py: 1,
    maxWidth: 200,
  },
  // Contorno fixo em todos os swatches, independente da cor preenchida — sem isso, tons claros
  // (ex: amarelo) ficam com pouco contraste contra o proprio fundo do menu
  swatchButton: {
    width: 26,
    height: 26,
    padding: 0,
    border: `1px solid ${theme.palette.divider}`,
  },
  swatchNoneIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
  },
});

export default styles;
